import { decodeJwtPayload } from '../utils/jwt';
export class EnvironmentService {
    constructor(uiFrameAdapter) {
        this.uiFrameAdapter = uiFrameAdapter;
    }
    async determineEnvironment() {
        const origin = window.origin;
        const { dev: devOrigins, stage: stageOrigins, prod: prodOrigins } = EnvironmentService.origins;
        if (devOrigins.includes(origin)) {
            return 'dev';
        }
        if (stageOrigins.includes(origin)) {
            return 'stage';
        }
        if (prodOrigins.includes(origin)) {
            const payload = decodeJwtPayload(await this.uiFrameAdapter.accessTokenFactory());
            return payload.dr === 'eu' ? 'prodeu' : 'prod';
        }
        if (origin === 'http://localhost' || origin.startsWith('http://localhost:')) {
            return 'local';
        }
        console.error('Zero trust library is running in an unexpected environment.');
        return 'local';
    }
}
EnvironmentService.origins = {
    dev: [
        'https://dev01-console.gotoresolve.com',
        'https://dev01-console.gotomypc.com',
        'https://zerotrust-modal.services-dev01.gotoresolve.com',
    ],
    stage: [
        'https://stage-console.gotoresolve.com',
        'https://stage-console.gotomypc.com',
        'https://zerotrust-modal.services-stage.gotoresolve.com',
    ],
    prod: [
        'https://console.gotoresolve.com',
        'https://console.gotomypc.com',
        'https://zerotrust-modal-eu.services.gotoresolve.com',
        'https://zerotrust-modal.services.gotoresolve.com',
    ],
};
